import { Week_Grid_List } from '@app/post-lists/week-grid-list'
import { List_Manage_Assembly_Presenter } from '@app/controllers/assembly-controller'
import { Ctx } from '@app/context'
import { Grid_Results, Mapped_Results } from '@app/post-lists/grid-list'
import { GT_Project } from '../../types/projects'
import { DateTime } from 'luxon'
import { GT_Remaining_Work } from '../../types/remaining-work'
import { List_Manage_Status_Workers_Presenter } from '@app/controllers/workers-controller'
import SubmitEvent = JQuery.SubmitEvent;
import ClickEvent = JQuery.ClickEvent;

export class Week_Status_List extends Week_Grid_List {
    assembly_presenter: List_Manage_Assembly_Presenter
    status_workers_presenter: List_Manage_Status_Workers_Presenter

    constructor( ctx: Ctx ) {
        super( ctx )

        this.set_projects( ctx.projects )
        this.set_dates( ctx.dates )
        this.set_remaining_work( ctx.remaining_work )

        this.init_columns()

        this.assembly_presenter = new List_Manage_Assembly_Presenter( this )
        this.status_workers_presenter = new List_Manage_Status_Workers_Presenter( this )

        this.render_results()
    }

    public ready() {
        super.ready()
        this.init_forms()
        this.init_actions()
        this.assembly_presenter.ready()
        this.status_workers_presenter.ready()
    }

    init_forms() {
        jQuery( '#form-approve-remaining-work' ).form(
            {
                fields: {
                    'remaining-work-status-approve': {
                        rules: [
                            {
                                type: 'notEmpty',
                                prompt: 'Bitte einen Bereich angeben.'
                            }
                        ]
                    }
                },
                revalidate: true,

                // @ts-expect-error Overload
                onSuccess: ( e: SubmitEvent ) => this.approve_remaining_work( e ),
                onFailure: app.show_toast_invalid_form, // wichtig: return false nötig, sonst Submit Event.
            }
        )
    }

    init_events() {
        super.init_events()
        jQuery( '.list-projects .grid-container' ).on(
            'click',
            ( e ) => {
                const target: HTMLElement = e.target.closest( '.column-item' ) as HTMLElement

                console.log( 'list click', e.target, target )

                if ( e.target.dataset.action === 'approve-remaining-work-item' ) {
                    this.init_modal_approve_remaining_work( target )
                    return
                }
            }
        )
    }

    init_actions() {
        jQuery( '[data-action="complete-remaining-work"]' ).on( 'click', ( e: ClickEvent ) => this.complete_remaining_work_confirmation( e ) )
    }

    protected map_results(): Mapped_Results {
        const mapped_results: Map<string, Grid_Results> = new Map()

        for ( const column of this.columns.keys() ) {
            mapped_results.set(
                column,
                [
                    ...gt_results.remaining_work.filter( work => work.status?.slug === column ).sort( this.sort_remaining_work_results ),
                    ...gt_results.projects.filter( project => project.status?.slug === column ),
                ]
            )
        }

        console.log( 'list columns', this.columns )
        console.log( 'filtered projects', mapped_results )

        return mapped_results
    }

    protected render_project( key: string, result: GT_Project ) {
        console.log( 'render', result.post_type, result, key )

        const column = this.columns.get( key ) as HTMLElement
        const container: HTMLElement|null = column.querySelector( '.column-projects' )

        if ( ! container ) {
            return
        }

        const post: HTMLDivElement = document.createElement( 'div' )
        post.dataset.postId = result.post_id.toString()
        post.classList.add( 'column-item', 'project-item' )

        post.appendChild( this.create_project_schedule_title( post, result ) )
        post.appendChild( this.create_project_substatus( post, result ) )
        post.appendChild( this.create_project_production_start( post, result ) )
        post.appendChild( this.create_project_status_deadline( post, result ) )
        post.appendChild( this.create_project_assembly_dates( post, result ) )
        post.appendChild( this.create_project_status_workers( post, result ) )
        post.appendChild( this.create_project_remaining_work( post, result ) )

        container.append( post )
    }

    protected render_remaining_work( key: string, result: GT_Remaining_Work ) {
        console.log( 'render', result.post_type, result, key )

        const container: HTMLElement|null = document.querySelector( `.column[data-column="${key}"] .column-projects` )

        if ( ! container ) {
            return
        }

        const post: HTMLDivElement = document.createElement( 'div' )
        post.dataset.postId = result.post_id.toString()
        post.classList.add( 'column-item', 'remaining-work-item' )

        post.appendChild( this.create_remaining_work_title( post, result ) )
        post.appendChild( this.create_remaining_work_project_title( post, result ) )
        post.appendChild( this.create_remaining_work_approval() )

        container.append( post )
    }

    protected create_project_production_start( _post: HTMLDivElement, project: GT_Project ): HTMLDivElement {
        const div: HTMLDivElement = document.createElement( 'div' )

        const { deadlines, status } = project

        div.classList.add( 'project-production-start' )

        if ( status?.slug !== 'planning' ) {
            return div
        }

        div.innerHTML = `
	        Produktionsbeginn bis:<br>
	        <span class="badge"><i class="calendar alternate outline icon"></i> ${format_date( deadlines[status.slug].date )}</span>
        `

        return div
    }

    protected create_project_status_deadline( _post: HTMLDivElement, project: GT_Project ): HTMLDivElement {
        const div: HTMLDivElement = document.createElement( 'div' )

        const { deadlines, status } = project

        div.classList.add( 'project-status-deadline' )

        if ( status?.slug === 'planning' ) {
            return div
        }

        if ( ! deadlines || ! ( status.slug in deadlines ) ) {
            return div
        }

        div.innerHTML = `
	        Fertigstellung bis:<br>
	        <span class="badge"><i class="calendar alternate outline icon"></i> ${format_date( deadlines[status.slug].date )}</span>
	    `

        return div
    }

    protected create_project_substatus( _post: HTMLDivElement, project: GT_Project ): HTMLDivElement {
        const div: HTMLDivElement = document.createElement( 'div' )

        div.classList.add( 'project-substatus' )

        if ( ! project.substatus ) {
            return div
        }

        div.dataset.projectStatus = project.status?.slug

        div.innerHTML = `<span class="badge status secondary">${project.substatus?.name}</span>`

        return div
    }

    protected create_remaining_work_approval(): HTMLDivElement {
        const div = document.createElement( 'div' )

        div.innerHTML = `
            <div class="title">
                <button class="ui button" data-action="approve-remaining-work-item">freigeben</button>
            </div>
        `

        return div
    }

    protected ajax_load_week_posts( day: DateTime|null = null ) {
        this.week_filter.disable_week_interactions()

        const monday: DateTime = day ? day : this.week_filter.get_current_monday()

        if ( ! monday.isValid ) {
            return false
        }

        const { ajax_url, nonce } = gt_ajax_object

        const action = 'load_week_projects'

        const data = {
            action,
            start: monday.toFormat( 'yyyy-MM-dd' ),
            end: monday.plus( { weeks: 1 } ).toFormat( 'yyyy-MM-dd' ),
            week: monday.toFormat( 'WW/kkkk' ),
            nonce,
        }

        console.log( 'AJAX data', data )

        jQuery.ajax(
            {
                url: ajax_url,
                type: 'POST',
                dataType: 'json',
                data,
                cache: false
            }
        ).done(
            ( response ) => {
                console.log( 'AJAX response', response )

                this.set_projects( response.projects.filter( ( el: GT_Project ): boolean => el.status.slug !== 'completed' ) )
                this.set_remaining_work( response.remaining_work ?? [] )
                this.set_dates( response.dates ?? [] )

                this.render_results()

                this.week_filter.enable_week_interactions()
            }
        )
    }

    init_modal_approve_remaining_work( item: HTMLElement ) {
        const post_id: number = Number( item.dataset.postId )
        const post: GT_Remaining_Work|undefined = gt_results.remaining_work.find( el => el.post_id === post_id )
        console.log( 'approve remaining work', item, post_id, post )

        if ( ! post ) {
            throw new Error( 'keine Restarbeit gefunden' )
        }

        const modal = app.get_modal( 'approve-remaining-work' )
        const dropdown = jQuery( '#remaining-work-status-approve-dropdown' )

        console.log( dropdown )

        const form = jQuery( '#form-approve-remaining-work' )

        // resets.
        form.form( 'reset' )
        dropdown.find( '.item.disabled' ).removeClass( 'disabled' )

        // sets.
        jQuery( '.remaining-work-post-id', form ).val( post.post_id )
        dropdown.find( `.item[data-value="${post.status.term_id}"]` ).addClass( 'disabled' )

        modal.modal( { autofocus: false } ).modal( 'show' )
    }

    approve_remaining_work( e: SubmitEvent ) {
        console.log( 'approve remaining work', e.currentTarget )

        // enable AJAX.
        e.preventDefault()

        const form      = jQuery( e.currentTarget )
        const form_data = form.serialize()

        const form_buttons  = jQuery( '.form-actions button', form )
        const submit_button = jQuery( '.submit', form )
        form_buttons.attr( 'disabled', 'disabled' )
        submit_button.addClass( 'loading elastic' )

        const { nonce, ajax_url } = gt_ajax_object

        const data = {
            action: 'approve_remaining_work',
            form_data,
            nonce
        }

        console.log( 'AJAX data', data )

        jQuery.ajax(
            {
                url: ajax_url,
                type: 'POST',
                dataType: 'json',
                data,
                cache: false
            }
        ).done(
            ( response ) => {
                console.log( 'AJAX response', response )

                form_buttons.removeAttr( 'disabled' )
                submit_button.removeClass( 'loading elastic' )

                const { success, data, error, toast } = response

                if ( success === false ) {
                    app.show_toast_ajax_response( data.toast, 'error' )

                    if ( app.is_debug_enabled() ) {
                        app.show_toast_ajax_response( data.error, 'error' )
                    }
                    return
                }

                if ( error ) {
                    app.show_toast_ajax_response( toast, 'error' )
                    return
                }

                app.show_toast_ajax_response( toast )

                app.get_modal( 'approve-remaining-work' ).modal( 'hide' )
                this.reload_results()
            }
        )
    }

    complete_remaining_work_confirmation( e: ClickEvent ) {
        console.log( 'complete remaining work?', e.currentTarget )

        const confirmation = app.get_modal( 'complete-remaining-work-confirm' )

        confirmation.modal(
            {
                onApprove: () => {
                    console.log( 'approved' )
                    this.complete_remaining_work( e )
                }
            }
        )
        confirmation.modal( 'show' )
    }

    complete_remaining_work( e: ClickEvent ) {
        console.log( 'complete remaining work', e.currentTarget )

        // enable AJAX
        e.preventDefault()

        const modal   = app.get_modal( 'approve-remaining-work' )
        const post_id = Number( modal.find( '.remaining-work-post-id' ).val() )

        console.log( 'complete remaining work', post_id )

        const { nonce, ajax_url } = gt_ajax_object

        const data = {
            action: 'complete_remaining_work',
            post_id,
            nonce
        }

        console.log( 'AJAX data', data )

        jQuery.ajax(
            {
                url: ajax_url,
                type: 'POST',
                dataType: 'json',
                data,
                cache: false
            }
        ).done(
            ( response ) => {
                console.log( 'AJAX response', response )

                const { success, data, error, toast } = response

                if ( success === false ) {
                    app.show_toast_ajax_response( data.toast, 'error' )

                    if ( app.is_debug_enabled() ) {
                        app.show_toast_ajax_response( data.error, 'error' )
                    }
                    return
                }

                if ( error ) {
                    app.show_toast_ajax_response( toast, 'error' )
                    return
                }

                app.show_toast_ajax_response( toast )

                this.reload_results()
            }
        )
    }
}
